import { useEffect, useRef } from 'react';

function useOutsideClick(callback: () => void) {
    const ref = useRef<HTMLElement | null>(null);

    useEffect(() => {
        function handleClick(event: MouseEvent) {
            if (!ref.current) return;

            if (!ref.current.contains(event.target as Node)) {
                callback();
            }
        }

        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [callback]);

    return ref;
}

export { useOutsideClick };
